import { Badge, Space, Tag, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import {
  alertsColumnIconMap,
  dateFormat,
  statusTextMap,
  tagColorMap,
  tagMap
} from "../../../../../Utils/utils"

dayjs.extend(utc)

const { Text } = Typography

export const defaultColumns = [
  { field_id: "status", label: "Status", active: true },
  { field_id: "endpoint_name", label: "Webhook URL", active: true },
  { field_id: "created_timestamp", label: "Date", active: true }
]

export const getColumns = ({ theme }) => ({
  status: {
    key: "status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Status",
        sorter: true,
        stateData: state,
        key: "status"
      }),
    dataIndex: "status",
    // fixed: 'left',
    // width: 120,
    render: (value, record) => {
      return (
        <Tag
          color={tagMap[value?.toLowerCase()] || "default"}
          key={value}
          style={{ margin: 0 }}
          className={"simple large"}
        >
          <Space>
            <Badge status={tagMap[value?.toLowerCase()] || "default"} color={tagColorMap[value]} />
            <Text>{statusTextMap[value] || value}</Text>
          </Space>
        </Tag>
      )
    }
  },
  source_id: {
    key: "source_id",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Source ID",
        sorter: true,
        stateData: state,
        key: "source_id"
      }),
    dataIndex: "source_id",
    // width: 128,
    render: (value, record) => <Text>{value}</Text>
  },
  created_timestamp: {
    key: "created_timestamp",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Date",
        sorter: true,
        stateData: state,
        key: "created_timestamp"
      }),
    dataIndex: "sent_at",
    // width: 140,
    render: (value, record) => (
      <Space size={4}>
        <Text>{dayjs(value || record?.created).format(dateFormat)}</Text>
        <Text type="secondary">{dayjs(value || record?.created).format("h:mm A [(UTC)]")}</Text>
      </Space>
    )
  }
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  width: 185,
  ellipsis: true,
  render: (_) => _ || "—"
})

// export const getActionColumn = ({onSelectRow}) => {

//   const handleAction = (e, data, type) => {
//     e.preventDefault()
//     e.stopPropagation()
//     onSelectRow(data, type)
//   }
//   return {
//     key: 'actions',
//     title: '',
//     width: 70,
//     render: (_, record) => (
//       <Flex>
//         <Tooltip title="Add event">
//           <ButtonComponent
//             type="link"
//             icon={<Icon type={'plus'} />}
//             onClick={e => handleAction(e, record, 'add_event')}
//             className="flex center "
//           />
//         </Tooltip>
//       </Flex>
//     ),
//   }
// }
